import { Component, OnInit, OnDestroy, Inject, Optional } from '@angular/core';
import { PershingTranslationService, PermissionCheckerService } from '@pershing/pershing-core';
import { NxiNavigation, PortalNavigationService } from '@pershing/nxi-ng-common';
import { Router } from '@angular/router';
import { NavigationConstants } from '../utils/navigation.constants';
@Component({
    selector: 'screener-navigation',
    templateUrl: 'screener-navigation.component.html'
})
export class ScreenerNavComponent implements OnInit, OnDestroy {
    fourthNavLinks: any[];
    selectedFourthPageId: any;
    navigation: NxiNavigation;
    layout: string;
    currentUrl: string;
    isEntitledStockScreener: boolean;
    isEntitledETFScreener: boolean;
    isEntitledMFScreener: boolean;
    isAdaTheme: boolean = false;

    constructor(
        private translationService: PershingTranslationService,
        private navigationService: PortalNavigationService,
        private router: Router,
        private authService: PermissionCheckerService,
        @Optional() @Inject('AppSettings') appSettings: any) {
            if (appSettings.themeType && appSettings.themeType === 'ada') {
                this.isAdaTheme = true;
            }
         }

    ngOnInit(): void {
        console.log(' In Component OnInit ');
        this.isEntitledStockScreener = this.authService.isEntitled(NavigationConstants.MOD_STOCK_SCREENER);
        this.isEntitledETFScreener = this.authService.isEntitled(NavigationConstants.MOD_ETF_SCREENER);
        this.isEntitledMFScreener = this.authService.isEntitled(NavigationConstants.MOD_MUTUAL_FUND_SCREENER);
        this.currentUrl = this.router.url;
        this.currentUrl = this.currentUrl.slice(this.currentUrl.lastIndexOf('/') + 1);
        this.navigationService.getGrandChildPage().subscribe(
            currentpage => {
                if (currentpage !== undefined) {
                    this.selectedFourthPageId = currentpage.id;
                    if (currentpage.children !== undefined) {
                        this.fourthNavLinks = currentpage.children;
                        if (this.fourthNavLinks.length > 0) {
                            this.selectedFourthPageId = this.fourthNavLinks[0].id;
                            // this.layout = this.fourthNavLinks[0].layout;
                            console.log(' 4rd grandchildpage-- ' + this.selectedFourthPageId);
                        }
                    }
                }
            });
        // this.navigationService.getGrandChildPage().subscribe(
        //     grandchildpage => {
        //         if (grandchildpage) {
        //             this.selectedThirdPageId = grandchildpage.id;
        //         }
        //         console.log(' 3rd grandchildpage-- ' + this.selectedThirdPageId);
        //     }
        // );
    }
    public ngOnDestroy() {
        console.log(' In FourthLevelComponent Destroy ');
    }
    handleChildNavigation(pageName): void {
        console.log('screeners Nav: ', pageName);
        this.currentUrl = pageName;
        document.dispatchEvent(new CustomEvent('portal.gotoview', {
            detail: {
                'domain': 'account',
                'value': '',
                'gotoPage': '/nxi/research/investtools/screeners/' + pageName
            }
        }));
    }
}
